import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { EMPTY, Observable, of } from "rxjs";
import { mergeMap, take } from "rxjs/operators";

import { ProductModel } from "../models/product.model";
import { DataService } from "../services/data/data.service";

@Injectable({
  providedIn: "root"
})
export class ProductResolverService implements Resolve<ProductModel> {
  constructor(private dataService: DataService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ProductModel> | Observable<never> {
    const id = route.paramMap.get("productId");
    const uid = route.paramMap.get("profileId");
    const tourneeId = route.paramMap.get("tourneeId");
    const action = route.paramMap.get('action');


    if (id == undefined) {
      const newItem = <ProductModel>{
        details: {
          currency: "EUR",
          quantityMetric: "piece",
          unitPriceQuantityMetric: "kilogram",
          sizeMetric: "gram",
          sizeDefaultExact: true,
          quantityMin: 1,
          quantityIncrement: 1,
          labels: {
            bio: false,
            bioConversion:false,
            labelRouge:false,
            aop:false,
            igp:false,
            pecheDurable:false
          },
          characteristics:{
            frozen:false
          }
        },
        status: "new",
        stockStatus: "available",
        producer: {
          key: uid
        }
      };
      return of(newItem);
    } 
    else if(tourneeId){
      return this.dataService.getTourneeProduct(id,tourneeId, uid).pipe(
        take(1),
        mergeMap(item => {
          if (item) {
            item.details.characteristics = item.details.characteristics || {};
            return of(item);
          } else {
            // id not found
            return EMPTY;
          }
        })
      );
    }
    
    else {
      return this.dataService.getProducerProduct(id, uid).pipe(
        take(1),
        mergeMap(item => {
          if (item) {
            if(action && action =='copy'){
              delete item.key;
              item.status = 'new';
              return of(item);
            }
            else{
              item.details.characteristics = item.details.characteristics || {};
              return of(item);
            }
          } else {
            // id not found
            return EMPTY;
          }
        })
      );
    }
  }
}
